var map = {
	"./Not_Using/atom-icon-arrow-down-dark.svg": 8119,
	"./Not_Using/atom-icon-arrow-up-dark.svg": 5167,
	"./Not_Using/atom-icon-play-dark.svg": 9658,
	"./Not_Using/atom-icon-search-dark.svg": 6259,
	"./atom-icon-close-dark.svg": 7603,
	"./atom-icon-discord-dark.svg": 4025,
	"./atom-icon-instagram-dark.svg": 2805,
	"./atom-icon-menu-dark.svg": 8985,
	"./atom-icon-twitter-dark.svg": 4442,
	"./iconDiscord.svg": 5299,
	"./iconInsta.svg": 2578,
	"./iconInsta2.svg": 3419,
	"./iconTwitter.svg": 5941,
	"./newtab.png": 8774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1199;